import React from "react";
import { getPaymentSummary } from "../utils/paymentSummary";
import { PaymentTaxSummary } from "../components/PaymentTaxSummary";

export function createTotalCostFormatter(onlinePaymentEnabled = false) {
  return function TotalCostFormatter(cellContent, row) {
    const summary = onlinePaymentEnabled ? getPaymentSummary(row) : null;
    if (summary) {
      return <PaymentTaxSummary summary={summary} />;
    }
    return (
      <span className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">
        {typeof row.totalCost !== "undefined" ? `$${row.totalCost.toFixed(2)}` : ""}
      </span>
    );
  };
}

export function TotalCostFormatter(cellContent, row) {
  return createTotalCostFormatter(false)(cellContent, row);
}
